import { useSelector } from 'react-redux';
import { CSSProperties } from 'styled-components';
import localStorage from 'utils/bom-dom-manipulation/local-storage';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { storageKeyName } from 'utils/generic/storage-key-name';
import { isMobile } from 'utils/is-mobile';
import { isActiveStreamTabMode } from 'utils/sportsbook/live-games-helper';
import { EMatchStreamingTypes } from 'interfaces/match-streaming';
import { useSbRouteMatch } from 'newhooks/generic/useSbRouteMatch';
import {
  getGamePreviewNotAvailable,
  getMatchStreamingGameData,
  getMatchStreamingType
} from 'store/selectors/match-streaming';

const MATCH_STREAM_SPORTS_HEIGHT = (() => {
  const matchStreamHeightSettings: {
    [key: number]: { [key: string]: string };
  } = {
    0: {
      ...(isMobile()
        ? { default: +SpringConfigs.MATCH_TRACKER_TYPE === 1 ? '136% ' : '56%' }
        : {
            default: +SpringConfigs.MATCH_TRACKER_TYPE === 1 ? '146%' : '59%',
            LeagueOfLegends: '74%',
            Dota2: '74%'
          })
    },
    1: {
      default: '69%'
    }
  };

  return (
    matchStreamHeightSettings[+SpringConfigs.JURISDICTION] ||
    matchStreamHeightSettings[0]
  );
})();

export const useStreamPlaceHolderStyles = (): CSSProperties => {
  const streamTypeFromLS = localStorage.getItem(
    storageKeyName('sportsbook', 'STREAM_ACTIVE_TAB_MODE')
  );

  const routeParams = useSbRouteMatch();
  const streamingType = useSelector(getMatchStreamingType);
  const { game } = useSelector(getMatchStreamingGameData) || {};
  const gamePreviewNotAvailable = useSelector(getGamePreviewNotAvailable);

  const closedMatchStreamingContent = [
    EMatchStreamingTypes.VOID,
    EMatchStreamingTypes.TIMELINE
  ].includes(streamTypeFromLS ? +streamTypeFromLS : streamingType);

  const containerAliasHeight =
    MATCH_STREAM_SPORTS_HEIGHT[game?.sport_alias || routeParams.params.sport];

  const isActiveStreamTab = isActiveStreamTabMode();

  return {
    zIndex: 2,
    position: 'relative',
    ...(isMobile() ? { backgroundColor: 'var(--v3-black-0)' } : {}),
    paddingTop: SpringConfigs.MOCKED_DATA
      ? MATCH_STREAM_SPORTS_HEIGHT.default
      : gamePreviewNotAvailable ||
        (isActiveStreamTab && !closedMatchStreamingContent)
      ? containerAliasHeight || MATCH_STREAM_SPORTS_HEIGHT.default
      : '0%'
  };
};
